import {
  MAIN_PROJECTS_FILTERS,
  MAIN_PROJECTS_FILTERS_WITHOUT_MY,
  NO_PROJECTS_MESSAGE_MAIN,
} from "app/constants";
import { useActiveFilter, useAuth } from "app/hooks";
import AuditIcon from "assets/img/audit-icon.svg";
import { FC } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useIdosQuery } from "store/api";
import { useAccount } from "wagmi";
import ProjectList from "../components/project/project.list";
import "./main.page.sass";

const MainPage: FC = () => {
  const { t } = useTranslation();
  const activeFilter = useActiveFilter();
  const { address } = useAccount()
  const { data: idos, isLoading, isFetching } = useIdosQuery({ activeFilter, address }, { refetchOnMountOrArgChange: true });
  const isAuth = useAuth();

  const filters = isAuth ? MAIN_PROJECTS_FILTERS : MAIN_PROJECTS_FILTERS_WITHOUT_MY;

  return (
    <div className="page">
      <div className="page__inner">
        <div className="page__title">
          <Trans i18nKey="closingNotice.title">
            <span className="_g-text-active-lighter">closing down</span>
          </Trans>
        </div>
        <div className="page__desc">{t("closingNotice.desc")}</div>
      </div>
      <div className="page__block">
        <ProjectList
          title="Projects on GAGARIN"
          projects={idos}
          filters={filters}
          isLoading={isLoading || isFetching || !idos}
          noProjectsMessage={NO_PROJECTS_MESSAGE_MAIN}
        />
      </div>
      <div className="page__inner">
        <a
          href="https://solidity.finance/audits/Gagarin/"
          target="_blank"
          className="main__audit"
          rel="noreferrer"
        >
          <img src={AuditIcon} alt="audit" className="main__audit-icon" />
          <div className="main__audit-title">{t("SOLIDITY.FINANCE AUDIT PASSED")}</div>
          <div className="main__audit-desc">{t("WE ARE AUDITED")}!</div>
        </a>
      </div>
    </div>
  );
};

export default MainPage;
